module.exports = __webpack_public_path__ + "img/header-memoireRingsConfigurator@2x.faa0474.jpg";